jQuery(document).ready(function ($) {
		

    // $(".sle-sipe-link p .sle-sipe-link-item").on("click", function () {
    // // メイン画像に切り替えるimgのsrc取得
    // img = $(this).attr("src");
    // // currentクラス付け替え(枠線などを変えたい時に)
    // $(".sle-sipe-link p").removeClass("current");
    // $(this).parent().addClass("current");
    // // fadeOutできたらsrc変更してfadeIn
    // $(".sle-sipe-bg img").fadeOut(500, function () {
    //   $(".sle-sipe-bg img")
    //     .attr("src", img)
    //     .on("load", function () {
    //       $(this).fadeIn(500);
    //     });
    // });
    //
    // });
		
	// $(".sle-sipe02-link p .sle-sipe02-link-item").on("click", function () {
    // // メイン画像に切り替えるimgのsrc取得
    // img = $(this).attr("src");
    // // currentクラス付け替え(枠線などを変えたい時に)
    // $(".sle-sipe02-link p").removeClass("current");
    // $(this).parent().addClass("current");
    // // fadeOutできたらsrc変更してfadeIn
    // $(".sle-sipe02-bg img").fadeOut(500, function () {
    //   $(".sle-sipe02-bg img")
    //     .attr("src", img)
    //     .on("load", function () {
    //       $(this).fadeIn(500);
    //     });
    // });
    //
    // });

  /*
  * Features section script 
  */
  // $(".sle-sipe03-link p .sle-sipe03-link-item").on("click", function () {
  //   // メイン画像に切り替えるimgのsrc取得
  //   img = $(this).attr("src");
  //   // currentクラス付け替え(枠線などを変えたい時に)
  //   $(".sle-sipe03-link p").removeClass("current");
  //   $(this).parent().addClass("current");
  //   // fadeOutできたらsrc変更してfadeIn
  //   $(".sle-sipe03-bg img").fadeOut(500, function () {
  //     $(".sle-sipe03-bg img")
  //       .attr("src", img)
  //       .on("load", function () {
  //         $(this).fadeIn(500);
  //       });
  //   });
  // });

  //$("#bg-movie").YTPlayer();

  // var myPlayer = $('#bg-sp-movie').YTPlayer({
  //   onReady: function (player) {
  //     let filters = {
  //       opacity: 100
  //     }
  //   myPlayer.YTPApplyFilters(filters)
  //   }
  // });

  // function checkBreakPoint() {
  //   if ($(window).width() < 768) {
  //     $('.js-sle-giulia-slidebox').slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       infinite: false,
  //       arrows: true,
  //       variableWidth: true,
  //       adaptiveHeight: true
  //     });
  //   } else {
  //     $('.js-sle-giulia-slidebox').slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       infinite: false,
  //       arrows: true,
  //       dots: true,
  //       variableWidth: true,
  //       customPaging : function(slider, i) { console.log('slider:', $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav'));
  //         var slidernav = $(slider.$slides[i]).find('.sle-slider-slideitem').data('slidernav');//$(slider.$slides[i].children[0]).data('slidernav');
  //         return '<a class="sle-slider-slideitem-title">'+slidernav+'</a>';
  //       },
  //     });
  //   }
  // }

  // // ウインドウがリサイズする度にチェック
  // $(window).resize(function(){
  //   checkBreakPoint();
  // });
  // // 初回チェック
  // checkBreakPoint();
});	
      




/*function checkBreakPoint() {
  
  if ($(window).width() < 768) {
    $('.js-sle-giulia-slidebox').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      variableWidth: true,
    });
    $('.js-sle-stelvio-slidebox').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      variableWidth: true,
    });
  }else{
    // PC向け
    $('.js-sle-giulia-slidebox.slick-initialized').slick('unslick');
    $('.js-sle-stelvio-slidebox.slick-initialized').slick('unslick');
  }
  }
  // ウインドウがリサイズする度にチェック
  $(window).resize(function(){
    checkBreakPoint();
  });
  // 初回チェック
  checkBreakPoint();*/